module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/04a34cafd4ce4a8db665d21fcba81eb5.png";